export default __webpack_public_path__ + "static/media/en.5aa2f382.svg";